import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon, Select, SelectItem, IndexPath, CheckBox, Input, Modal,Card } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Image, Dimensions, View } from 'react-native';
import { Done } from './done.js'
import { QrScreen } from './qr.screen.js'
import { showMessage, hideMessage } from "react-native-flash-message";
import { setInvoice } from '../../../store/actions/request'
import {useSelector, useDispatch} from 'react-redux';
import trackerApi from '../../api/tracker';
import * as RootNavigation from '../../../root.navigation.js';
import AsyncStorage from '@react-native-async-storage/async-storage';
import JalaliCalendarPicker from 'react-native-persian-jalali-calendar-picker';
import { useIsFocused } from "@react-navigation/native";

const AlertIcon = (props) => (
  <Icon {...props} name='alert-triangle' style={{width:24, height:24, marginHorizontal:5}} fill='#FF3B38'/>
);
  const CardIcon = (props) => (
    <Icon {...props}  name='credit-card'/>
  );


  const PlusIcon = (props) => (
    <Icon {...props}  name='plus-square-outline'/>
  );

  const category = [
    'در بازکن تصویری',
    'در بازکن کنترلی'
  ]
  let model = [
    [],
    []
  ]
  const  width= Dimensions.get('window').width-40
  const  height= Dimensions.get('window').height
export const Invoice = () => {
  const data = useSelector( state => state.request.data);
  const [serviceSelectedIndex, setServiceSelectedIndex] = useState(new IndexPath(0));
  const [checked, setChecked] =  useState(false)
  const [checked2, setChecked2] =  useState(false)
  const [notCorp, setNotCorp] = useState('')
  const [serialNo, setSerialNo] = useState('')
  const [productionDate, setProductionDate] = useState('')
  const [productList, setProductList] = useState('')
  const [catIndex, setCatIndex] = React.useState(new IndexPath(0));
  const [modelIndex, setModelIndex] = React.useState(new IndexPath(0));
  const [serverModels, setServerModels] = React.useState([]);
  const [actions, setActions] = React.useState([]);
  const [visible, setVisible] = React.useState(false);
  const [visible2, setVisible2] = React.useState(false);
  const [qr, setQr] = React.useState(false);
  const [explain, setExplain] = React.useState('');
  const [dateModal, setDateModal] = React.useState(false)
  const isVisible = useIsFocused();

  const dispatch = useDispatch()

  React.useEffect(()=>{
    model = [
      [],
      []
    ]
    getData();
  },[])
  const getData = async ()=>{
    const token =  await AsyncStorage.getItem('userId');

    const response0 = await trackerApi.post('/invoice/status', {request_id: data.id}, {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response0.data.status){
    if(response0.data.results && response0.data.results.status != 'deliver') {
      dispatch(setInvoice(response0.data.results))
      RootNavigation.navigate('CompleteTask')
    }
    else{
    const response = await trackerApi.post('/get/productsWithBrand', {model: data.product_model});
    console.log(response.data);
    if(response.data.status) setServerModels(response.data.allData);
    response.data.allData.map((data)=>{
      if(data.product_cat==category[0]){
        model[0].push(data.product_name)
    } else if(data.product_cat==category[1]){
      model[1].push(data.product_name)
    }
  }
  )
}
} else {
  showMessage({
    message: `خطای دیتابیس`,
    type: "danger",
  });
}
}

const saveDeviceInfo = async()=>{
  const token =  await AsyncStorage.getItem('userId');
  console.log(actions);
  const response = await trackerApi.post('/invoice/new_invoice',
    {
      warranty: checked,
      productionDate,
      model:model[catIndex.row][modelIndex-1],
      product_cat: category[catIndex.row],
      serialNo,
      request_id: data.id,
      explain,
      actions,
      sherkati: checked2,
      sherkati_desc: notCorp
    } ,
    {
      headers: {Authorization: `Bearer ${token}`}
    });
  if(response.data.status) {
    console.log('data saved!');
    setVisible(false)
    RootNavigation.navigate('CompleteTask')
  }
  else showMessage({
    message: `لطفا اقدامات را تکمیل فرمایید`,
    type: "danger",
  });
}

const sendToFactory = async()=>{
  const token =  await AsyncStorage.getItem('userId');
  const response = await trackerApi.post('/update/request_status',
    {
      status: 'factory',
      reqID: data.id,
      addInvoice: true,
      warranty: checked,
      productionDate,
      model:model[catIndex.row][modelIndex-1],
      product_cat: category[catIndex.row],
      serialNo,
      explain,
      actions,
      sherkati: checked2
    } ,
    {
      headers: {Authorization: `Bearer ${token}`}
    });
  if(response.data.status) {
    setVisible(false)
    showMessage({
      message: response.data.message,
      type: "success",
    });
    RootNavigation.navigate('Menu')
  }
  else showMessage({
    message: `خطای پایگاه داده`,
    type: "danger",
  });
}

const toggleQr = () => {
  setQr(!qr)
}

const CropIcon = (props) => (
  <Icon {...props}  name='crop' onPress={toggleQr}/>
);

  return (
      <Layout level='3' style={styles.container}>
        <View style={{justifyContent:'space-between', alignItems:'flex-start', width, flex:1}}>
        <Text category='c1' appearance='hint' style={{textAlign:'center'}}>اطلاعات دستگاه</Text>

        <Layout style={{borderRadius:15 , width}}>

        <Select
          style={{flex:1, margin:10, width:width-20}}
          label={evaProps => <Text {...evaProps}>محصول</Text>}
          selectedIndex={catIndex}
          value = {category[catIndex.row]}
          onSelect={index => setCatIndex(index)}>
          {
            category.map((data)=>{
              return (
                <SelectItem title={data} key={catIndex} />
              )
            })
          }
        </Select>

        <Select
          style={{flex:1, margin:10, width:width-20}}
          label={evaProps => <Text {...evaProps}>مدل</Text>}
          selectedIndex={modelIndex}
          value = {model[catIndex.row][modelIndex-1]}
          onSelect={index =>  setModelIndex(index)}>
          {
            model[catIndex.row].map((data)=>{
              return (
                <SelectItem title={data} key={modelIndex} />
              )
            })
          }
        </Select>
        <Input
          placeholder ='شماره سریال روی محصول'
          value={serialNo}
          label='شماره سریال(بارکد qr)'
          onChangeText = {newValue =>{ setSerialNo(newValue)}}
          accessoryRight={CropIcon}
          style={{margin:10}}
          />
          { qr &&
          <View style={{height: height/3}}>
            <QrScreen setSerialNo = {setSerialNo} toggle={toggleQr}/>
          </View>
          }
          <Input
            placeholder ='1401/01/01'
            value={productionDate}
            label='تاریخ تولید محصول'
            // onChangeText = {newValue =>{ setProductionDate(newValue)}}
            onChangeText = {newValue =>{ setDateModal(true)}} // For web
            style={{margin:10}}
            onTouchStart = {() =>{ setDateModal(true)}}

            />
        <CheckBox
          style={{marginVertical:10, marginHorizontal:15}}
          checked={checked}
          onChange={nextChecked => setChecked(nextChecked)}>
          <Text>
            دارای گارانتی
          </Text>
        </CheckBox>

        <CheckBox
          style={{marginVertical:10, marginHorizontal:15}}
          checked={checked2}
          onChange={nextChecked => {setChecked2(nextChecked); setNotCorp('')}}>
          <Text>
            کار غیر شرکتی
          </Text>
        </CheckBox>
      { checked2 &&
        <Input
          placeholder ='توضیحات'
          value={notCorp}
          label='توضیحات کار غیر شرکتی'
          // onChangeText = {newValue =>{ setProductionDate(newValue)}}
          onChangeText = {newValue =>{ setNotCorp(newValue)}} // For web
          style={{margin:10}}
          />
}

        </Layout>
        <Done model={model[catIndex.row][modelIndex-1]} setActions={setActions} actions={actions}/>
        <Input
          placeholder ='توضیحات'
          value={explain}
          label='توضیحات'
          onChangeText = {newValue =>{ setExplain(newValue)}}
          style={{width}}
          multiline={true}
          />

        <Text category='c1' appearance='hint' style={{marginTop:15}}>* در صورت صدور پیش فاکتور، فقط در تاریخ همان روز معتبر می‌باشد.</Text>
        <Text category='c1' appearance='hint' style={{marginTop:5, marginBottom:20}}>* در صورتی که دستگاه برای تعمیر بایستی به کارخانه ارسال شود از قسمت ارسال به کارخانه اقدام نمایید.</Text>

        <View style={{flexDirection:'row', width, marginBottom: 20}}>
          <View style={{flex: 2, marginHorizontal: 6}}>
            <Button status='danger' appearance='outline' size='small' style={{borderRadius:10, flex:1, marginVertical:3}} onPress={()=> RootNavigation.navigate('canceling')} >لغو کار</Button>
            <Button size='small'  style={{borderRadius:10,flex:1, marginVertical:3}} onPress={()=> setVisible2(true)} >ارسال به کارخانه</Button>
            <Button appearance='outline' size='small' style={{borderRadius:10, flex:1, marginVertical:3}} onPress={()=> RootNavigation.navigate('home')} >بازگشت</Button>
          </View>
          <Button style={{borderRadius:10, flex:1, marginVertical:3}} status='success'  onPress={()=>{
            if (serialNo.length>3) setVisible(true)
            else showMessage({
              message: 'شماره سریال دستگاه را به درستی وارد کنید.',
              type: "warning",
            });
          }
          } >تکمیل سرویس </Button>
        </View>



        </View>
        <Modal
           visible={visible}
           backdropStyle={styles.backdrop}
           onBackdropPress={() => setVisible(false)}>
           <Card disabled={false}>
           <Text style={{marginBottom:10}} category='h6' status='primary'>تکمیل سرویس</Text>
           <Text style={{marginBottom:10}}>در صورت تایید دیگر امکان ویرایش وجود ندارد. لطفا اطلاعات را بررسی کرده و در صورت صحت اطلاعات ادامه دهید.</Text>
             <View style={{flexDirection:'row', justifyContent:'flex-end'}}>
             <Button appearance='ghost' style={{marginHorizontal:5}} onPress={()=>{setVisible(false)}}>
               انصراف
             </Button>
             <Button style={{marginHorizontal:5}} onPress={()=>{saveDeviceInfo()}}>
                ادامه
              </Button>
              </View>
           </Card>
         </Modal>

         <Modal
            visible={visible2}
            style={{width:width+20}}
            backdropStyle={styles.backdrop}
            onBackdropPress={() => setVisible2(false)}>
            <Card disabled={false} style={{padding:10}}>
            <Text style={{marginBottom:10}} category='h6' status='primary'>ارسال به کارخانه</Text>
            <Text style={{marginBottom:10, lineHeight:25}}>می‌خواهید دستگاه را برای سرویس به کارخانه ارسال کنید؟</Text>
            <View style={{flexDirection:'row', alignItems:'center', marginBottom:15}}>
            <AlertIcon /><Text style={{marginBottom:10}} status='danger' category='c2'> در صورت انتخاب این گزینه کار تکمیل شده است و دیگر امکان ویرایش آن وجود ندارد.</Text>
            </View>
              <View style={{flexDirection:'row', justifyContent:'flex-end'}}>
              <Button appearance='ghost' style={{marginHorizontal:5, flex:1}} onPress={()=>{setVisible2(false)}}>
                انصراف
              </Button>
              <Button style={{marginHorizontal:5, flex:2}} onPress={()=>{sendToFactory()}}>
                 ادامه
               </Button>
               </View>
            </Card>
          </Modal>
          <Modal
             visible={dateModal}
             style={{width:width-20}}
             backdropStyle={styles.backdrop}
             onBackdropPress={() => setDateModal(false)}>
             <Card disabled={false} style={{backgroundColor:'#f5f5f5'}}>
             <JalaliCalendarPicker onDateChange={date => {
               setProductionDate(date)
               setDateModal(false)
               }
             }
               minY='1370'
               headerStyleText={{fontFamily: 'IRANYekanBold'}}
               weekStyleText={{fontFamily: 'IRANYekanBold'}}
               headerStyleTextCenter={{fontFamily: 'IRANYekanBold'}}
             />
             </Card>
           </Modal>

      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    justifyContent:'space-around',
    alignItems:'center'
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
});
